/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pending_ReportsInputs */

const en_pending_reports = /** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Reports`)
};

const id_pending_reports = /** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan Tertunda`)
};

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const es_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const fr_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const de_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const ja_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const zh_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const ar_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const it_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const ru_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const pt_pending_reports = en_pending_reports;

/** @type {(inputs: Pending_ReportsInputs) => LocalizedString} */
const ko_pending_reports = en_pending_reports;

/**
* | output |
* | --- |
* | "Pending Reports" |
*
* @param {Pending_ReportsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pending_reports = /** @type {((inputs?: Pending_ReportsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pending_ReportsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pending_reports(inputs)
	if (locale === "es") return es_pending_reports(inputs)
	if (locale === "fr") return fr_pending_reports(inputs)
	if (locale === "de") return de_pending_reports(inputs)
	if (locale === "ja") return ja_pending_reports(inputs)
	if (locale === "zh") return zh_pending_reports(inputs)
	if (locale === "ar") return ar_pending_reports(inputs)
	if (locale === "id") return id_pending_reports(inputs)
	if (locale === "it") return it_pending_reports(inputs)
	if (locale === "ru") return ru_pending_reports(inputs)
	if (locale === "pt") return pt_pending_reports(inputs)
	return ko_pending_reports(inputs)
});